module.exports = __webpack_public_path__ + "img/i_badge.2568e515.svg";